<div *ngIf="shouldShowTotalOrderedWeight$ | async">
  <div class="text--small text--gray spacing--padding-top">
    {{ 'cart-processing.total-ordered-weight-kg' | translate }}
  </div>
  <div class="text--large total-ordered-weight" data-test="confirmation__weight-information">
    {{ totalOrderedWeight$ | async }}
    {{ 'unit.KG' | translate }}
  </div>
</div>
